/**
 * Legal Types
 *
 * Types for cookie consent and legal compliance tracking.
 * Based on Doc 14: Legal Policies
 */

/**
 * Cookie consent status
 */
export type CookieConsentStatus = 'pending' | 'accepted' | 'rejected' | 'customized'

/**
 * Cookie preference categories
 */
export interface CookiePreferences {
  necessary: true // Always enabled
  analytics: boolean
  marketing: boolean
}

/**
 * Default cookie preferences
 */
export const DEFAULT_COOKIE_PREFERENCES: CookiePreferences = {
  necessary: true,
  analytics: false,
  marketing: false,
}
